import React from "react";
import './story.css';
import MuiDrawer from './MuiDrawer';
import BottomBox from './BottomBox';
import Helmet from 'react-helmet';
import TeamBox from './TeamBox';
import Pop from './Pop';
import { Box } from '@mui/material';

function Story (props) {
  const {history} = props;
    return(
      
        <div  className="whole__story">
          
      <body>
      <Helmet bodyAttributes={{style: 'background-color : white'}}/> 
      <Pop btcolor='black'/>
          <Box 
                sx = {theme => ({ [theme.breakpoints.up('sm')]:{backgroundColor:'#202020',width:'100%',height:'50vh',maxHeight:'50%'},
                [theme.breakpoints.between('0','600')]:{backgroundColor:'#202020',width:'100%',height:'35vh',maxHeight:'50%'}
                })}
            
            />
        
        <p onClick={()=> history.push('/')} className='story__head'>
          Untouched
        </p>
      
        <div className='story__heading'>
          <p>Our Story</p> 
          </div>
        <div className="maincontainer">
        
          <div className="contain2">
              <span className="storyheading">How We Started?</span>
              <p className="head2">We believe in innovation that serves the need of the hour. As a team, we strive to find ways in which technology can give back to society's.problems.</p>
              <div className="story">
                
                <p>The idea struck our founder,<b>Shariq Ahmed</b>, at an ATM, just at the beginning of lockdown, when he saw that people were keeping a safe distance, not just from each other, but also the hand sanitiser kept there, for fear of touching it. It occurred to him that sadly, the world was becoming contactless, and to survive it and serve it better, one must go Untouched.</p>
                <p>
                <p>This project is an effort to expand our abilities and inventiveness so that
society should get benefit in these difficult times. And our dedicated team
has been working tirelessly to bring this project to market after months
of coordination.</p>
                </p>
              </div>
          </div>
          <div className="contain1">
            <img id='storyimg' src="images/storyPage_img.png" alt="" />
            <span>People at ATM Machine at the time of first lockdown in india</span>
          </div>
          
          </div>
          
          
          <TeamBox/>
          
          <BottomBox/>
          
          
          
      </body>
    </div>

    );
}
 
export default Story;